<template>
  <div class="content personal-reward" style="padding: 10px; width: 790px">
    <div class="personal-reward__title">虚拟奖品</div>
    <div class="personal-reward__bar">
      <span class="label">奖品类别：</span>
      <span
        v-for="(item, i) in tabs"
        :key="item.type"
        class="item"
        :class="{ cur: item.cur }"
        @click="
          changeCur(i)
          $util.clickStat(
            `GRZX/WDJP/${item.name}`,
            `个人中心/我的奖品/${item.title}`
          )
        "
        >{{ item.title }}</span
      >
    </div>
    <div class="recharge-table-container">
      <table class="recharge-table">
        <thead>
          <tr>
            <th width="200px">物品名称</th>
            <th width="150px">礼包来源</th>
            <th width="180px">获得时间</th>
            <th width="180px">有效期</th>
            <th width="180px">激活码</th>
            <th width="80px">奖品详情</th>
            <th width="150px">操作</th>
          </tr>
        </thead>
        <tbody v-if="list.length">
          <tr v-for="(item, index) in list" :key="item.code">
            <td class="ellipsis-1" :title="item.title || item.gift_title">
              {{ item.title || item.gift_title }}
            </td>
            <td class="ellipsis-1" :title="item.channel || item.act_title">
              {{ item.channel || item.act_title || '-' }}
            </td>
            <td>{{ $dayjs(item.created_at).format('YYYY-MM-DD HH:mm:ss') }}</td>
            <td>
              {{ $dayjs(item.expire_time).format('YYYY-MM-DD HH:mm:ss') }}
            </td>
            <td class="ellipsis-1" :title="item.code">
              {{ item.code || '无' }}
            </td>
            <td>
              <a
                href="javascript:;"
                @click="
                  $util.clickStat(
                    `GRZX/WDJP/YXLB/LB${index + 1}/CK`,
                    `个人中心/我的奖品/游戏礼包/礼包${index + 1}/查看`
                  )
                  showDetail(item)
                "
                >查看</a
              >
            </td>
            <td>
              <button
                v-if="!isVip"
                class="btn-copy"
                @click="
                  $util.clickStat(
                    `GRZX/WDJP/YXLB/LB${index + 1}/FZ`,
                    `个人中心/我的奖品/游戏礼包/礼包${index + 1}/复制`
                  )
                  doCopy(item)
                "
              >
                复制
              </button>
              <button
                v-if="item.state === 'valid'"
                class="btn-use"
                @click="
                  $util.clickStat(
                    `GRZX/WDJP/YXLB/LB${index + 1}/SY`,
                    `个人中心/我的奖品/游戏礼包/礼包${index + 1}/使用`
                  )
                  goUse(item)
                "
              >
                去使用
              </button>
              <button
                v-else-if="item.state === 'used' || isVip"
                class="btn-used"
              >
                已使用
              </button>
              <button v-else class="btn-invalid">不可用</button>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="!list.length" class="recharge-table__empty">
        暂无{{ curTab.title }}
      </div>
    </div>
    <Pagination :page="pages" @change="getGiftList($event)" />
  </div>
</template>

<script>
import Pagination from '~/components/common/Pagination'
export default {
  components: {
    Pagination
  },
  data() {
    return {
      page: 1,
      size: 10,
      total: 0,
      gifts: {},
      style: {}
    }
  },
  computed: {
    pages() {
      return Math.ceil(this.total / this.size)
    },
    curTab() {
      return this.tabs.filter((e) => e.cur)[0]
    },
    isVip() {
      return this.curTab.type === 'xlvip'
    },
    list() {
      return (
        (this.isVip ? this.gifts.vip_gift_list : this.gifts.coupon_list) || []
      )
    }
  },
  watch: {
    curTab(val) {
      this.page = 1
      this.total = 0
      this.getGiftList(1)
      this.getCount()
    }
  },
  asyncData({ query }) {
    const { gift_type = 'package' } = query
    return {
      tabs: [
        // { title: '全部', type: 'all', cur: false },
        {
          title: '游戏礼包',
          name: 'YXLB',
          type: 'package',
          cur: gift_type === 'package'
        },
        {
          title: '迅雷代金券',
          name: 'DJQ',
          type: 'voucher',
          cur: gift_type === 'voucher'
        },
        {
          title: '迅雷现金券',
          name: 'XJQ',
          type: 'cash',
          cur: gift_type === 'cash'
        },
        {
          title: '迅雷折扣卷',
          name: 'ZKJ',
          type: 'discount',
          cur: gift_type === 'discount'
        },
        {
          title: '迅雷盒子优惠券',
          name: 'XLHZ',
          type: 'thunder',
          cur: gift_type === 'thunder'
        }
        // { title: '迅雷白金会员', type: 'xlvip', cur: false }
      ]
    }
  },
  created() {
    if (process.client) {
      this.getCount()
      this.getGiftList(1)
    }
  },
  methods: {
    getPageSize() {
      const size = this.$refs.table.getBoundingClientRect().height / 50
      this.size = Math.floor(size) - 1
      this.style = {
        height: this.size * 50 + (this.size + 1) + 'px'
      }
    },
    showDetail({ body }) {
      this.$notify({
        title: '奖品名称',
        type: '',
        message: body,
        btnTxt: '确认',
        duration: -1
      })
    },
    changeCur(i) {
      this.tabs.forEach((e) => (e.cur = false))
      this.tabs[i].cur = true
    },
    getCount() {
      this.$request('userGiftCount', {
        body: {
          user_id: this.$cookies.get('userid'),
          gift_type: this.curTab.type
        }
      }).then((data = {}) => (this.total = data.count))
    },
    getGiftList(page) {
      this.$request('userGiftList', {
        body: {
          user_id: this.$cookies.get('userid'),
          gift_type: this.curTab.type,
          page,
          size: this.size
        }
      })
        .then((data = {}) => {
          this.gifts = data
          this.page = page
        })
        .catch((err) => {
          this.$notify(err.message)
        })
    },
    doCopy({ code }) {
      this.$copyText(code).then(() => this.$notify('复制成功'))
    },
    goUse(item) {
      if (item.gift_type === 'package') {
        this.$util.playGame({
          game_id: item.bind_game_id,
          server_id: item.bind_server_id
        })
      } else {
        this.$util.goRecharge({
          game_id: item.bind_game_id,
          server_id: item.bind_server_id,
          coupon_code: item.code,
          coupon_id: item.coupon_id,
          coupon_type: item.gift_type
        })
      }
    }
  }
}
</script>
